export const PROTEIN_TAG_NAME_MAPPINGS = {
  '1': 'protein_beef',
  '2': 'protein_chicken',
  '3': 'protein_pork',
  '4': 'protein_fish',
  '5': 'protein_shellfish',
  '6': 'protein_smoked_fish',
  '7': 'protein_tofu_tempeh',
  '16': 'protein_lamb',
  '9': 'protein_beans_lentils',
  '10': 'protein_plant_based_meat_alternatives',
};

export const SPICY_LEVEL_TAG_NAME_MAPPINGS = {
  '19': 'spice_no_heat',
  '20': 'spicy_level_mild',
  '21': 'spicy_level_medium',
  '22': 'spicy_level_hot',
};

export const OCCASION_TAG_NAME_MAPPINGS = {
  '47': 'featured_breakfast_friendly',
  '48': 'featured_lunch_friendly',
  '49': 'featured_kid_friendly',
  '50': 'featured_family_friendly',
};

export const MARKETING_TAG_NAME_MAPPINGS = {
  '124': 'featured_dietitian_picks',
  '194': 'featured_support_your_system',
  '125': 'featured_high_fiber',
};

export const CERTIFICATION_TAG_NAME_MAPPINGS = {
  '15': 'certification_organic',
  '49': 'certification_non_gmo',
  '141': 'certification_kosher',
  '142': 'certification_gluten_free',
};

// not on the spreadsheet but it's a filter
export const SERVINGS_TAG_NAME_MAPPINGS = {
  '1': 'servings_1',
  '2': 'servings_2',
  '3': 'servings_3',
  '4': 'servings_4',
  '5': 'servings_5',
};

export const FILTER_NAME_MAPPINGS = {
  is_vegan: 'diet_vegan',
  is_vegetarian: 'diet_vegetarian',
  is_pescatarian: 'diet_pescatarian',
  is_dairy_free: 'diet_dairy_free',
  is_gluten_free: 'diet_gluten_free',
  is_soy_free: 'diet_soy_free',
  is_nut_free: 'diet_nut_free',
  is_peanut_free: 'diet_peanut_free',
  is_popular: 'popular_recipes',
  is_seasonal: 'seasonal_recipes',
  is_egg_free: 'diet_egg_free',
  is_shellfish_free: 'diet_shellfish_free',
  filter_favorites: 'saved_recipes',
  is_new: 'featured_newest_additions',
  is_favorite: 'saved_groceries',
  is_carb_conscious: 'nutriton_carb_conscious',
  is_less_sugar: 'nutriton_less_sugar',
  is_high_protein: 'nutriton_high_protein',
  is_less_sodium: 'nutriton_less_sodium',
  is_anti_inflammatory: 'nutriton_anti_inflammatory',
  is_low_calorie: 'nutriton_low_calorie',
  is_low_fat: 'nutriton_low_fat',
  is_low_carb: 'nutriton_low_carb',
  is_low_sugar: 'nutriton_low_sugar',
  is_breakfast: 'featured_breakfast_friendly',
  is_breakfast_friendly: 'featured_breakfast_friendly',
  is_lunch: 'featured_lunch_friendly',
  is_lunch_friendly: 'featured_lunch_friendly',
  is_kid_friendly: 'featured_kid_friendly',
  is_family_friendly: 'featured_family_friendly',
  is_best_price: 'featured_best_price',
  is_heat_and_eat: 'featured_heat_and_eat',
  is_paleo: 'nutriton_paleo_friendly',
  low_fodmap: 'nutriton_low_fodmap',
  is_featured: 'featured_chef_picks',
  protein: PROTEIN_TAG_NAME_MAPPINGS,
  // for recipes
  spicy_levels: SPICY_LEVEL_TAG_NAME_MAPPINGS,
  // for groceries
  spicy_level: SPICY_LEVEL_TAG_NAME_MAPPINGS,
  certification_tags: CERTIFICATION_TAG_NAME_MAPPINGS,
  servings: SERVINGS_TAG_NAME_MAPPINGS,
  is_marketing: MARKETING_TAG_NAME_MAPPINGS,
};

export const GROCERY_FILTER_NAME_MAPPINGS = {
  ...FILTER_NAME_MAPPINGS,
  // these are the overlapping keys which prevents us from having one map
  is_recent: 'recent_groceries',
};

export const RECIPE_FILTER_NAME_MAPPINGS = {
  ...FILTER_NAME_MAPPINGS,
  is_recent: 'recent_recipes',
};
